import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import PageMetaLoader from '../components/PageMetaLoader';
const ContactPage = () => {
  const form = useRef<HTMLFormElement>(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    
    // Initialize EmailJS with your public key
    emailjs.init("YOUR_PUBLIC_KEY"); // Replace with your actual EmailJS public key
    
    emailjs.sendForm(
      'YOUR_SERVICE_ID', // Replace with your actual EmailJS service ID
      'YOUR_TEMPLATE_ID', // Replace with your actual EmailJS template ID
      form.current as HTMLFormElement
    )
    .then((result) => {
      console.log('Email successfully sent!', result.text);
      setFormSubmitted(true);
      setIsSubmitting(false);
      
      // Reset form after 5 seconds
      setTimeout(() => {
        setFormSubmitted(false);
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          subject: '',
          message: ''
        });
      }, 5000);
    })
    .catch((error) => {
      console.error('Failed to send email:', error);
      setError('Failed to send email. Please try again later.');
      setIsSubmitting(false);
    });
  };

  return (
    <ContactContainer>
      <PageMetaLoader pageUrl="contact" />
      <PageHeader>
        <h1>Contact Us</h1>
        <p>Get in touch with our team to learn more about our solutions</p>
      </PageHeader>

      <ContactContent>
        <ContactInfo>
          <h2>Our Information</h2>
          <p>Feel free to reach out to us through any of these channels:</p>
          
          <InfoItem>
            <IconWrapper>
              <FaMapMarkerAlt />
            </IconWrapper>
            <div>
              <h3>Address</h3>
              <p>#160, St. 10, Borey Peng Heng,Sangkat Prey Vaeng, Dangkao, Phnom Penh, Cambodia</p>
            </div>
          </InfoItem>
          
          <InfoItem>
            <IconWrapper>
              <FaPhone size={20} />
            </IconWrapper>
            <div>
              <h3>Phone</h3>
              <p>+855 010 440 600</p>
            </div>
          </InfoItem>
          
          <InfoItem>
            <IconWrapper>
              <FaEnvelope size={20} />
            </IconWrapper>
            <div>
              <h3>Email</h3>
              <p>info@akas.co</p>
              <p>support@akas.co</p>
            </div>
          </InfoItem>
          
          <InfoItem>
            <IconWrapper>
              <FaClock size={20} />
            </IconWrapper>
            <div>
              <h3>Business Hours</h3>
              <p>Monday - Friday: 8:00 AM - 5:00 PM</p>
              <p>Saturday: 9:00 AM - 12:00 PM</p>
            </div>
          </InfoItem>
        </ContactInfo>

        {/* <ContactFormContainer>
          <h2>Send us a Message</h2>
          <p>Fill out the form below and we'll get back to you as soon as possible.</p>

          {formSubmitted ? (
            <SuccessMessage>
              <h3>Thank you for contacting us!</h3>
              <p>We have received your message and will get back to you shortly.</p>
            </SuccessMessage>
          ) : (
            <ContactForm ref={form} onSubmit={handleSubmit}>
              <FormRow>
                <FormGroup>
                  <label htmlFor="name">Full Name*</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </FormGroup>
                
                <FormGroup>
                  <label htmlFor="email">Email Address*</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </FormGroup>
              </FormRow>

              <FormRow>
                <FormGroup>
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </FormGroup>
                
                <FormGroup>
                  <label htmlFor="company">Company Name</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                  />
                </FormGroup>
              </FormRow>

              <FormGroup>
                <label htmlFor="subject">Subject*</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </FormGroup>

              <FormGroup>
                <label htmlFor="message">Message*</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </FormGroup>

              {error && <ErrorMessage>{error}</ErrorMessage>}

              <SubmitButton type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </SubmitButton>
            </ContactForm>
          )}
        </ContactFormContainer> */}
      </ContactContent>

      {/* <MapSection>
        <h2>Visit Our Office</h2>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d250273.72379094877!2d104.73672782345057!3d11.579761926152409!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3109513dc76a6be3%3A0x9c010ee85ab525bb!2sPhnom%20Penh!5e0!3m2!1sen!2skh!4v1650182044693!5m2!1sen!2skh"
          width="100%"
          height="450"
          style={{ border: 0, borderRadius: '10px' }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Office Location"
        ></iframe>
      </MapSection> */}
    </ContactContainer>
  );
};

const ContactContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem 4rem;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
  
  h1 {
    font-size: 2.5rem;
    color: var(--primary-color);
    margin-bottom: 1rem;
  }
  
  p {
    font-size: 1.2rem;
    max-width: 600px;
    margin: 0 auto;
    color: var(--text-dark);
  }
`;

const ContactContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 3rem;
  margin-bottom: 4rem;
  
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const ContactInfo = styled.div`
  background-color: var(--primary-color);
  color: white;
  padding: 2.5rem;
  border-radius: 10px;
  
  h2 {
    font-size: 1.8rem;
    margin-bottom: 1rem;
  }
  
  > p {
    margin-bottom: 2rem;
    opacity: 0.9;
  }
`;

const InfoItem = styled.div`
  display: flex;
  margin-bottom: 1.5rem;
  
  h3 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
  }
  
  p {
    opacity: 0.9;
    margin: 0.25rem 0;
  }
`;

const IconWrapper = styled.div`
  font-size: 1.5rem;
  margin-right: 1rem;
  margin-top: 0.25rem;
`;

const ContactFormContainer = styled.div`
  background-color: white;
  padding: 2.5rem;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  
  h2 {
    font-size: 1.8rem;
    color: var(--primary-color);
    margin-bottom: 1rem;
  }
  
  > p {
    margin-bottom: 2rem;
    color: var(--text-dark);
  }
`;

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  
  label {
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: var(--text-dark);
  }
  
  input, textarea {
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
    font-size: 1rem;
    transition: border-color 0.3s ease;
    
    &:focus {
      outline: none;
      border-color: var(--primary-color);
    }
  }
  
  textarea {
    resize: vertical;
  }
`;

const ErrorMessage = styled.div`
  background-color: #fee2e2;
  border: 1px solid #f87171;
  color: #b91c1c;
  padding: 0.75rem;
  border-radius: 5px;
  margin-bottom: 1rem;
  font-size: 0.9rem;
`;

const SubmitButton = styled.button`
  background-color: var(--primary-color);
  color: white;
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 40px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-start;
  
  &:disabled {
    background-color: #94a3b8;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
  
  &:hover:not(:disabled) {
    background-color: var(--accent-color);
    transform: translateY(-3px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
  
  @media (max-width: 576px) {
    align-self: stretch;
  }
`;

const SuccessMessage = styled.div`
  background-color: #ebf8ef;
  border: 1px solid #84e1a6;
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
  
  h3 {
    color: #10b981;
    margin-bottom: 1rem;
    font-size: 1.3rem;
  }
  
  p {
    color: var(--text-dark);
  }
`;

const MapSection = styled.div`
  h2 {
    font-size: 1.8rem;
    color: var(--primary-color);
    margin-bottom: 1.5rem;
    text-align: center;
  }
`;

export default ContactPage; 